<template>
  <select :disabled="disabled == true" ref="selectForm">
    <slot></slot>
  </select>
</template>

<script>
  export default {
    props: ['value', 'disabled'],
    watch: {
      value: function (value) {
        this.reload(value)
      },
      disabled: function (value) {
        let that = this

        setTimeout(function () {
          that.reset()
        }, 100)
      }
    },
    methods: {
      reload: function (value) {
        let select = $(this.$el)
        //console.log('RELOAD', select);
        let newValue = value || this.value
        select.val(newValue)

        if (newValue && newValue != '') {
          select.closest('.input-field').addClass('select-active')
        }

        select.formSelect()
      },
      reset: function () {
        let vm = this
        let elem = $(this.$el)
        var instance = M.FormSelect.getInstance(elem)
        instance.destroy()

        elem.formSelect()

      }
    },
    mounted: function () {
      let vm = this
      let select = $(this.$el)

      select
        .val(this.value)
        .on('change', function () {
          vm.$emit('input', $(this).val())
        })

      select.formSelect()

      bus.$on('updateFormCliente', function () {
        if (vm.$refs.selectForm == undefined)
          return

        vm.reload()
      })
    },
    updated () {
      if (this.$refs.selectForm == undefined)
        return

      this.reload()

      if (typeof Materialize.updateTextFields != 'undefined')
        Materialize.updateTextFields()
    },
    destroyed: function () {
      let elem = $(this.$el)

      var instance = M.FormSelect.getInstance(elem)
      instance.destroy()
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/utils/MaterialSelect.vue